import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function ShareIcon(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="13.653" height="13.748" viewBox="0 0 13.653 13.748" {...props}>
      <defs>
        <style>
          {`.cls-5{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.75px}`}
        </style>
      </defs>
      <g id="Group_5963" transform="rotate(-90 -47.869 861.236)">
        <g id="Group_5817" transform="translate(805.041 913.218)">
          <path id="Line_457" d="M0 0L6.632 0" class="cls-5" transform="translate(0 2.713)"/>
          <path id="Path_6435" d="M816.356 915.015s2.717 2.1 2.717 2.717-2.717 2.71-2.717 2.71" class="cls-5" transform="translate(-811.622 -915.015)"/>
        </g>
        <g id="Group_5818" transform="translate(800.494 909.98)">
          <path id="Path_6436" d="M807.82 909.981c-1.617-.013-3.734.053-5.851.2a1.413 1.413 0 0 0-1.253 1.212 46.587 46.587 0 0 0 0 9.079 1.413 1.413 0 0 0 1.253 1.212c1.856.127 3.711.193 6.073.2" class="cls-5" transform="translate(-800.494 -909.98)"/>
        </g>
      </g>
    </SvgIcon>
  );
}

export default ShareIcon;


// WEBPACK FOOTER //
// ./src/components/icons/ShareIcon.jsx